import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons/faLightbulbOn'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck'
import { faMicrophoneStand } from '@fortawesome/pro-regular-svg-icons/faMicrophoneStand'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import Wrapper from '../shared/Wrapper'

const LANDING_PAGE_STEPS = [
  'Enter a task & star working',
  'Your coach keeps you on track',
  'Get your Productivity Score',
]

const COACH_PAGE_STEPS = [
  {
    icon: <FontAwesomeIcon icon={faListCheck} />,
    text: 'It is an online office where all your fans meet everyday to work together',
  },
  {
    icon: <FontAwesomeIcon icon={faMicrophoneStand} />,
    text: 'Your voice nudges them when they get distracted and congratulates them when they finish',
  },
  {
    icon: <FontAwesomeIcon icon={faLightbulbOn} />,
    text: 'They get a Productivity Score along with helpful insights, tips and videos',
  },
]

interface CrushYourWorkProps {
  context?: 'landing-page' | 'coach-landing-page'
}

export default function CrushYourWork({
  context = 'landing-page',
}: CrushYourWorkProps): JSX.Element {
  const [highlightedIdx, setHighlightedIdx] = useState(0)

  return (
    <Wrapper>
      <div className="flex flex-col-reverse md:flex-row items-center gap-8 py-20 md:pt-0">
        <video
          muted
          autoPlay
          loop
          playsInline
          className="flex-shrink-0"
          onTimeUpdate={(e) => {
            // @ts-expect-error
            const currentTime = e.target.currentTime

            if (currentTime > 6 && currentTime < 17) {
              setHighlightedIdx(1)
            } else if (currentTime > 17) {
              setHighlightedIdx(2)
            } else {
              setHighlightedIdx(0)
            }
          }}
          width={600}
          height={460}
        >
          <source src="/assets/v5-main.webm" type="video/webm" />
          <source src="/assets/v5-main.mp4" type="video/mp4" />
        </video>

        <div>
          <h1 className="font-semibold text-3xl mb-8">
            {context === 'landing-page'
              ? 'Crush Your Work 2x as Fast'
              : 'Sukha is the #1 online coworking community'}
          </h1>

          <ul
            className={`${context === 'coach-landing-page' ? 'space-y-4' : ''}`}
          >
            {context === 'landing-page' &&
              LANDING_PAGE_STEPS.map((step, i) => (
                <li key={i}>
                  <div className="flex items-center gap-4">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center border font-semibold transition-all ${
                        highlightedIdx !== i
                          ? 'border-white border-opacity-50'
                          : 'border-transparent bg-gradient-to-r from-v5-pink to-v5-orange'
                      } `}
                    >
                      {i + 1}
                    </div>

                    <h1
                      className={`transition-all ${
                        highlightedIdx === i
                          ? 'bg-gradient-to-r from-v5-pink to-v5-orange bg-clip-text text-transparent'
                          : 'text-white text-opacity-60'
                      }`}
                    >
                      {step}
                    </h1>
                  </div>

                  {i !== LANDING_PAGE_STEPS.length - 1 && (
                    <hr className="w-px h-8 ml-5 bg-white bg-opacity-50 border-none" />
                  )}
                </li>
              ))}

            {context === 'coach-landing-page' &&
              COACH_PAGE_STEPS.map((step, i) => (
                <li key={i}>
                  <div
                    className={`flex items-center gap-4 ${
                      i === highlightedIdx
                        ? 'text-v5-pink'
                        : 'text-white text-opacity-70'
                    }`}
                  >
                    <div className={`transition-all text-xl`}>{step.icon}</div>

                    <h1 className={`transition-all max-w-sm`}>{step.text}</h1>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </Wrapper>
  )
}
